export interface CDBurnerFilter {
  pk: number,
  filterTag: string,
  filterCondition: FilterConditionKey,
  filterValue: string,
  notes: string,
  enabled: boolean
}

export type FilterConditionKey = keyof typeof FilterCondition;

export enum FilterCondition {
  STARTS_WITH = 'starts with',
  CONTAINS = 'contains',
  EQUALS = 'equals'
}

export default function burnerFilters(state: CDBurnerFilter[] = [], action: any): CDBurnerFilter[] {
  switch (action.type) {
    case 'GET_BURNER_FILTERS_FULFILLED':
      return action.response.data;
    default:
      return state;
  }
}

